/**
 * @flow
 */

// eslint-disable-next-line i18next/no-literal-string
export const signalOrgNodesInputChanged = "signal-org-nodes-input-changed";
